/* The two server-rendered lists are authoritative; motion is progressive enhancement. */
(() => {
  const section = document.querySelector('[data-clientele]');
  if (!section || !window.IntersectionObserver || !window.ResizeObserver) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const rows = [...section.querySelectorAll('[data-clientele-row]')];
  const speed = 24;
  let generation = 0;

  const measure = row => {
    const width = row.querySelector('.homepage-clientele__set:not([data-clientele-clone])').getBoundingClientRect().width;
    row.style.setProperty('--clientele-distance', `${width}px`);
    row.style.setProperty('--clientele-duration', `${width / speed}s`);
  };
  const resize = new ResizeObserver(records => records.forEach(({ target }) => measure(target.closest('[data-clientele-row]'))));
  rows.forEach(row => resize.observe(row.querySelector('.homepage-clientele__set')));

  const visibility = new IntersectionObserver(records => {
    records.forEach(({ target, isIntersecting }) => target.classList.toggle('is-visible', isIntersecting));
  });
  rows.forEach(row => visibility.observe(row));

  async function prepare(row, version) {
    const set = row.querySelector('.homepage-clientele__set:not([data-clientele-clone])');
    // Native lazy loading alone misses logos far along a transformed strip. Warm
    // each complete row near the section, then start only after every image decodes.
    const images = [...set.querySelectorAll('img')];
    images.forEach(img => { img.loading = 'eager'; });
    await Promise.all(images.map(img => img.decode().catch(() => {})));
    if (version !== generation || reduced.matches || images.some(img => !img.naturalWidth)) return;
    const clone = set.cloneNode(true);
    clone.dataset.clienteleClone = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('role', 'presentation');
    clone.removeAttribute('aria-label');
    clone.querySelectorAll('li').forEach(li => li.setAttribute('role', 'presentation'));
    clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
    // Prepending for the rightward row starts at the FRONT of the canonical set.
    row.querySelector('.homepage-clientele__track')[row.dataset.clienteleRow === '2' ? 'prepend' : 'append'](clone);
    measure(row);
    row.scrollLeft = 0;
    row.classList.add('is-ready');
  }

  const warm = new IntersectionObserver(records => {
    if (!records.some(record => record.isIntersecting) || reduced.matches) return;
    warm.disconnect();
    rows.forEach(row => prepare(row, generation));
  }, { rootMargin: '1000px 0px' });

  function configure() {
    generation += 1;
    warm.disconnect();
    rows.forEach(row => {
      row.classList.remove('is-ready');
      row.querySelector('[data-clientele-clone]')?.remove();
      row.scrollLeft = 0;
    });
    if (!reduced.matches) warm.observe(section);
  }
  reduced.addEventListener('change', configure);
  configure();
})();
